import styled from 'styled-components';

const DefaultLayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export default DefaultLayoutWrapper;
